import ProductWithTranslucentDeal from "app/pages/Listing/Product/ProductWithTranslucentDeal";

export default props => <ProductWithTranslucentDeal {...props} />;
